<template>
	<el-dialog v-dialogDrag class="wechat-bind" title="绑定微信" :visible.sync="visible" width="420px" :before-close="onClose" :modal-append-to-body="false" :append-to-body="true">
		<div class="bind-container">
			<!-- 未绑定状态 -->
			<div v-if="!bindStatus" class="unbind-section">
				<div class="qrcode-section" v-if="qrcodeUrl">
					<div class="qrcode-wrapper">
						<img :src="qrcodeUrl" alt="微信扫码绑定" class="qrcode-img" />
						<div class="qrcode-mask" v-if="qrcodeExpired">
							<span class="expired-text">二维码已过期</span>
							<el-button type="primary" size="small" @click="refreshQrcode">刷新</el-button>
						</div>
					</div>
					<p class="tips">请使用微信扫一扫绑定账号</p>
					<p class="sub-tips">绑定后可接收消息通知</p>
				</div>
				<div v-else class="loading-section">
					<i class="el-icon-loading"></i>
					<p>正在生成二维码...</p>
				</div>
			</div>

			<!-- 已绑定状态 -->
			<div v-else class="binded-section">
				<div class="success-icon">
					<i class="el-icon-success"></i>
				</div>
				<h3>微信绑定成功</h3>
				<p class="tips">您已成功绑定微信，可以接收消息通知</p>
				<el-button type="danger" plain @click="onUnbind">解除绑定</el-button>
			</div>
		</div>
	</el-dialog>
</template>

<script>
export default {
	name: "wechatBind",
	props: {
		visible: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			bindStatus: false,
			qrcodeUrl: '',
			sceneStr: '',
			qrcodeExpired: false,
			checkInterval: null,
			expireTimer: null
		}
	},
	watch: {
		visible(val) {
			if (val) {
				this.getBindStatus();
			} else {
				this.clearTimers();
			}
		}
	},
	methods: {
		onClose() {
			this.clearTimers();
			this.$emit('close');
		},

		// 获取绑定状态
		getBindStatus() {
			this.$http({
				url: "/wechat/oa/bind/status",
				method: "get"
			}).then((data) => {
				this.bindStatus = data.bindStatus;
				if (!this.bindStatus) {
					this.generateQrcode();
				}
			}).catch(() => {
				this.$message.error("获取绑定状态失败");
			});
		},

		// 生成二维码
		generateQrcode() {
			this.qrcodeUrl = '';
			this.qrcodeExpired = false;
			this.$http({
				url: "/wechat/oa/qrcode/bind",
				method: "get"
			}).then((data) => {
				this.qrcodeUrl = data.qrcodeUrl;
				this.sceneStr = data.sceneStr;
				// 开始轮询检查绑定状态
				this.startCheckBindStatus();
				// 设置二维码过期时间（10分钟）
				this.setExpireTimer(600000);
			}).catch(() => {
				this.$message.error("生成二维码失败");
			});
		},

		// 刷新二维码
		refreshQrcode() {
			this.clearTimers();
			this.generateQrcode();
		},

		// 开始轮询检查绑定状态
		startCheckBindStatus() {
			this.clearInterval();
			this.checkInterval = setInterval(() => {
				this.$http({
					url: "/wechat/oa/bind/status",
					method: "get"
				}).then((data) => {
					if (data.bindStatus) {
						this.bindStatus = true;
						this.clearTimers();
						this.$message.success("微信绑定成功");
					}
				});
			}, 3000); // 每3秒检查一次
		},

		// 设置过期定时器
		setExpireTimer(delay) {
			this.clearTimeout();
			this.expireTimer = setTimeout(() => {
				this.qrcodeExpired = true;
				this.clearInterval();
			}, delay);
		},

		// 清除定时器
		clearTimers() {
			this.clearInterval();
			this.clearTimeout();
		},

		clearInterval() {
			if (this.checkInterval) {
				clearInterval(this.checkInterval);
				this.checkInterval = null;
			}
		},

		clearTimeout() {
			if (this.expireTimer) {
				clearTimeout(this.expireTimer);
				this.expireTimer = null;
			}
		},

		// 解绑微信
		onUnbind() {
			this.$confirm('确定要解除微信绑定吗？解除后将无法接收微信消息通知。', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: "/wechat/oa/bind/unbind",
					method: "post"
				}).then(() => {
				this.bindStatus = false;
				this.$message.success("解绑成功");
				// 关闭弹窗
				this.onClose();
			}).catch(() => {
				this.$message.error("解绑失败");
			});
			});
		}
	},
	beforeDestroy() {
		this.clearTimers();
	}
}
</script>

<style lang="scss" scoped>
.wechat-bind {
	.bind-container {
		padding: 20px;
		text-align: center;
	}

	.unbind-section {
		.qrcode-section {
			.qrcode-wrapper {
				position: relative;
				display: inline-block;
				border: 1px solid #e0e0e0;
				border-radius: 8px;
				padding: 10px;
				background: #fff;

				.qrcode-img {
					width: 200px;
					height: 200px;
					display: block;
				}

				.qrcode-mask {
					position: absolute;
					top: 0;
					left: 0;
					right: 0;
					bottom: 0;
					background: rgba(255, 255, 255, 0.9);
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: center;
					border-radius: 8px;

					.expired-text {
						color: #f56c6c;
						font-size: 14px;
						margin-bottom: 10px;
					}
				}
			}

			.tips {
				margin-top: 15px;
				color: #333;
				font-size: 14px;
			}

			.sub-tips {
				margin-top: 5px;
				color: #999;
				font-size: 12px;
			}
		}

		.loading-section {
			padding: 40px;

			.el-icon-loading {
				font-size: 40px;
				color: #409EFF;
			}

			p {
				margin-top: 15px;
				color: #666;
			}
		}
	}

	.binded-section {
		.success-icon {
			margin-bottom: 20px;

			.el-icon-success {
				font-size: 60px;
				color: #67c23a;
			}
		}

		h3 {
			color: #333;
			margin-bottom: 10px;
		}

		.bind-info {
			color: #666;
			font-size: 13px;
			margin-bottom: 15px;
		}

		.tips {
			color: #999;
			font-size: 12px;
			margin-bottom: 20px;
		}
	}
}
</style>
